export interface TokenStorage {
  get(key: string): string | null
  set(key: string, value: string): void
  remove(key: string): void
}

export class MemoryStorageAdapter implements TokenStorage {
  private store = new Map<string, string>()

  get(key: string): string | null {
    return this.store.get(key) ?? null
  }

  set(key: string, value: string): void {
    this.store.set(key, value)
  }

  remove(key: string): void {
    this.store.delete(key)
  }
}

export class SessionStorageAdapter implements TokenStorage {
  get(key: string): string | null {
    if (typeof window === "undefined") return null
    try {
      return sessionStorage.getItem(key)
    } catch {
      return null
    }
  }

  set(key: string, value: string): void {
    if (typeof window === "undefined") return
    try {
      sessionStorage.setItem(key, value)
    } catch {
      // Storage full or blocked
    }
  }

  remove(key: string): void {
    if (typeof window === "undefined") return
    try {
      sessionStorage.removeItem(key)
    } catch {
      // Storage blocked
    }
  }
}

export class LocalStorageAdapter implements TokenStorage {
  get(key: string): string | null {
    if (typeof window === "undefined") return null
    try {
      return localStorage.getItem(key)
    } catch {
      return null
    }
  }

  set(key: string, value: string): void {
    if (typeof window === "undefined") return
    try {
      localStorage.setItem(key, value)
    } catch {
      // Storage full or blocked
    }
  }

  remove(key: string): void {
    if (typeof window === "undefined") return
    try {
      localStorage.removeItem(key)
    } catch {
      // Storage blocked
    }
  }
}

export function createStorage(type: "memory" | "sessionStorage" | "localStorage"): TokenStorage {
  switch (type) {
    case "localStorage":
      return new LocalStorageAdapter()
    case "memory":
      return new MemoryStorageAdapter()
    case "sessionStorage":
    default:
      return new SessionStorageAdapter()
  }
}
